
/*export const environment = {
    production: false,
    keycloak: {
      baseUrl: 'https://liristech.com:8445',
      redirectBaseUrl: 'https://liristech.com:4200',
      realm: 'afcar-uat',
      clientId: 'afcar-we'
    },
    apiBaseUrl: 'https://liristech.com:8097'
  };



  export const environment = {
    production: false,
    keycloak: {
      baseUrl: 'https://liristech.com:8445',
      redirectBaseUrl: 'http://localhost:4200',
      realm: 'afcar-dev',
      clientId: 'afcar-we'
    },
    apiBaseUrl: 'http://liristech.com:8032'
  };

  */
  
  export const environment = {
    production: false,
    keycloak: {
      baseUrl: 'https://auth.liristech.com',
      redirectBaseUrl: 'https://pg.liristech.com',
      realm: 'afcar-dev',
      clientId: 'afcar-we'
    },
    apiBaseUrl: 'https://liristech.com:8432'
  };

  //baseUrl: 'https://liristech.com:8445',